module.exports = __webpack_public_path__ + "static/img/posterTop.655e49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posterTop.png
// module id = ccDb
// module chunks = 2